import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class GraphSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'graph');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('label.font.family', ['main', 'content', 'header']),
            this.sizeNumberField('label.font.size'),
            this.fontColorComboField('label.font.color', ['main', 'content', 'header']),
            this.comboField('palette', {
                'Default': 'default',
                'Dark Theme': 'nightrider',
            }),
        ];
    }

}
